'use-strict';

import PhotoSwipeLightbox from './photoswipe-lightbox.esm.min.js';
import Photoswipe from './photoswipe.esm.min.js';

class ZoomAction extends HTMLElement {
  constructor() {
    super();
    this.type = this.dataset.type || 'no_zoom';
    this.zoomOption = this.dataset.zoomOption || 'external';
    this.lightbox = null;
    this.drift = null;
    this.lightboxInitialized = false;
    this.init();
  }
  init() {
    if (this.type === 'no_zoom') return;
    window.addEventListener('resize', this.responsive.bind(this));
    window.addEventListener('load', this.responsive.bind(this));
  }
  initLightBox() {
    if (this.lightboxInitialized) return;
    this.lightboxInitialized = true;
    this.querySelectorAll('a.media-gallery__image').forEach((a) => {
      a.addEventListener('click', (e) => {
        e.preventDefault();
        const target = e.currentTarget;

        const visibleAnchors = Array.from(
          this.querySelectorAll('a.media-gallery__image')
        ).filter((el) => el.offsetParent !== null);

        const dataSource = visibleAnchors.map((el) => {
          const img = el.querySelector('img');
          let w = parseInt(el.getAttribute('data-pswp-width'));
          let h = parseInt(el.getAttribute('data-pswp-height'));
          if (!w || isNaN(w)) w = (img && img.naturalWidth) || 1500;
          if (!h || isNaN(h)) h = (img && img.naturalHeight) || 1500;
          return {
            src: el.getAttribute('href'),
            width: w,
            height: h,
            element: el,
          };
        });

        const openIndex = Math.max(visibleAnchors.indexOf(target), 0);

        if (this.lightbox) {
          this.lightbox.destroy();
          this.lightbox = null;
        }

        this.lightbox = new PhotoSwipeLightbox({
          dataSource: dataSource,
          pswpModule: () => Photoswipe,
          counter: false,
          zoom: false,
          preloader: false,
          arrowPrev: false,
          arrowNext: false,
          close: true,
          loop: false,
          bgOpacity: 1,
        });

        const removeBar = () => {
          document.querySelectorAll('.bls-bottom-bar').forEach((b) => b.remove());
        };

        const buildBar = () => {
          removeBar();
          const pswp = this.lightbox && this.lightbox.pswp;
          if (!pswp) return false;

          const bar = document.createElement('div');
          bar.className = 'bls-bottom-bar';

          const prev = document.createElement('button');
          prev.type = 'button';
          prev.className = 'bls-arrow bls-arrow-prev';
          prev.setAttribute('aria-label', 'Anterior');
          prev.innerHTML = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="7 1 1 7 7 13"></polyline></svg>';
          prev.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); pswp.prev(); });

          const counter = document.createElement('span');
          counter.className = 'bls-counter';
          const updateCounter = () => {
            counter.textContent = (pswp.currIndex + 1) + ' / ' + pswp.getNumItems();
          };

          const next = document.createElement('button');
          next.type = 'button';
          next.className = 'bls-arrow bls-arrow-next';
          next.setAttribute('aria-label', 'Próximo');
          next.innerHTML = '<svg width="8" height="14" viewBox="0 0 8 14" fill="none" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"><polyline points="1 1 7 7 1 13"></polyline></svg>';
          next.addEventListener('click', (ev) => { ev.preventDefault(); ev.stopPropagation(); pswp.next(); });

          bar.appendChild(prev);
          bar.appendChild(counter);
          bar.appendChild(next);
          document.body.appendChild(bar);

          updateCounter();
          pswp.on('change', updateCounter);
          pswp.on('destroy', removeBar);
          pswp.on('close', removeBar);
          return true;
        };

        this.lightbox.init();
        this.lightbox.loadAndOpen(openIndex);

        let attempts = 0;
        const tryBuild = () => {
          if (buildBar()) return;
          if (attempts++ < 20) setTimeout(tryBuild, 100);
        };
        setTimeout(tryBuild, 50);
      });
    });
  }
  initDrift() {
    if (typeof Drift === 'undefined') return;
    if (this.drift !== null) return;
    var allTriggers = this.querySelectorAll('.drift-trigger');
    var paneContainer = this.closest('.sec__featured-product').querySelector(
      '.zoom-external-area'
    );
    if (allTriggers.length != 0) {
      allTriggers.forEach((trigger) => {
        const inlineContainer = trigger.closest('[data-pane-container]');
        const zoomOption = this.zoomOption;
        if (zoomOption === 'inner-2') {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption === 'inner-2',
            zoomFactor: 3,
            containInline: paneContainer,
            paneContainer: inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () { inlineContainer.classList.add('relative'); },
            onHide: function () { inlineContainer.classList.remove('relative'); },
          });
        } else {
          this.drift = new Drift(trigger, {
            inlinePane: zoomOption,
            zoomFactor: 5,
            containInline: !!paneContainer,
            paneContainer: zoomOption === 'external' ? paneContainer : inlineContainer,
            hoverBoundingBox: zoomOption === 'external',
            onShow: function () { inlineContainer.classList.add('relative'); },
            onHide: function () { inlineContainer.classList.remove('relative'); },
          });
        }
      });
    }
  }
  responsive() {
    if (window.innerWidth >= 768) {
      if (this.type === 'open_lightbox' || this.type === 'zoom_on_icon_hover') {
        this.initLightBox();
      } else {
        if (this.lightbox !== null) {
          this.lightbox.destroy();
          this.lightbox = null;
          this.lightboxInitialized = false;
        }
        this.initDrift();
      }
    } else {
      if (this.type !== 'open_lightbox' && this.type !== 'zoom_on_icon_hover') {
        if (this.drift !== null) {
          this.drift.destroy();
          this.drift = null;
        }
        this.initLightBox();
      } else {
        this.initLightBox();
      }
    }
    this.updateSwiper();
  }

  updateSwiper() {
    if (typeof Swiper !== 'undefined') {
      if (this.querySelector('.thumbnail-slide')) {
        this.querySelector('.thumbnail-slide').swiper.update();
      }
    }
  }

  disconnectedCallback() {
    window.removeEventListener('resize', this.responsive.bind(this));
    window.removeEventListener('load', this.responsive.bind(this));
  }
}
customElements.define('zoom-action', ZoomAction);

// ── Zoom só na lupa: bloqueia clicks na imagem, deixa lupa funcionar ──
document.addEventListener('click', function(e) {
  var iconOnlyContainer = e.target.closest('[data-zoom-icon-only="1"]');
  if (!iconOnlyContainer) return;

  var anchor = e.target.closest('a.media-gallery__image');
  if (!anchor) return;

  var isLupaClick = e.target.closest('.zoom_light_box--hover-only');
  if (isLupaClick) return;

  e.preventDefault();
  e.stopPropagation();
}, true);